import { integrationService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  SET_INTEGRATIONS,
  REPLACE_INTEGRATION,
  REMOVE_INTEGRATION
} from './mutationTypes';
import {
  GET_INTEGRATIONS,
  UPDATE_INTEGRATION,
  GET_INTEGRATION_REFERENCES,
  DELETE_INTEGRATION
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from '@/store/helpers';

const actions = {
 /**
   * Get all Integrations
   */
  async [GET_INTEGRATIONS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_INTEGRATIONS });
    try {
      const response = await integrationService.getIntegrations(rootState.currentAccountId);
      commit(SET_INTEGRATIONS, response.data.integrations);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_INTEGRATIONS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_INTEGRATIONS, error: e });
    }
  },
  async [UPDATE_INTEGRATION]({ rootState, commit }, integration) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_INTEGRATION });
    try {
      const response = await integrationService.updateIntegration(rootState.currentAccountId, integration);
      commit(REPLACE_INTEGRATION, response.data.integration);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_INTEGRATION });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_INTEGRATION, error: e });
    }
  },
  async [GET_INTEGRATION_REFERENCES]({ rootState, commit }, integration) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_INTEGRATION_REFERENCES });
    try {
      const response = await integrationService.getReferences(rootState.currentAccountId, integration);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_INTEGRATION_REFERENCES });
      return response;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_INTEGRATION_REFERENCES, error: e });
    }
  },
  async [DELETE_INTEGRATION]({ rootState, commit }, integration) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_INTEGRATION });
    try {
      await integrationService.deleteIntegration(rootState.currentAccountId, integration);
      commit(REMOVE_INTEGRATION, integration);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_INTEGRATION });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_INTEGRATION, error: e });
    }
  },
};

export default actions;